<template>
  <v-row justify="center" class="mb-5">
    <v-col cols="12">
      <v-row class="text-center d-flex justify-center">
        <v-col cols="12">
          <p class="visto-subtitle text-black text-center text-uppercase mb-5">
            Visto em:
          </p>
        </v-col>
      </v-row>
      <div class="logo-scroller">
        <div class="logo-track">
          <div
            v-for="(item, index) in repeatedLogos"
            :key="index"
            class="logo-item"
          >
            <a
              :href="item.link"
              target="_blank"
              rel="noopener noreferrer"
              class="logo-link"
            >
              <v-img
                :src="require(`@/assets/logos-seen-in/${item.image}`)"
                height="100"
                width="250"
                contain
                class="logo-img"
                :alt="item.title"
              />
            </a>
          </div>
        </div>
      </div>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "SeenIn",
  data() {
    return {
      logos: [
        {
          image: "1.png",
          title: "Maker Market nasce com investimento de R$ 1 milhão",
          link: "https://startupi.com.br/maker-market-investimento-de-1-milhao",
        },
        {
          image: "4.png",
          title:
            "Empreendedor investe R$ 1 milhão em plataforma para impulsionar manufatura 3D no Brasil",
          link: "https://revistacapitaleconomico.com.br/noticias/empreendedorismo/empreendedor-investe-r-1-milhao-em-plataforma-para-impulsionar-manufatura-3d-no-brasil/",
        },
        {
          image: "2.png",
          title: "Maker Market nasce com investimento de R$ 1 milhão",
          link: "https://economiaempauta.com.br/maker-market-nasce-com-investimento-de-r-1-milhao/",
        },
        {
          image: "3.png",
          title: "Maker Market se torna residente do Parque Tecnológico",
          link: "https://pelotasparquetecnologico.com.br/ecossistema/ecossistema-tecnosul-residentes/",
        },
        {
          image: "5.svg",
          title:
            "O objetivo é criar uma rede nacional de pessoas com impressoras 3D",
          link: "https://ahoradosul.com.br/conteudos/2025/06/22/o-objetivo-e-criar-uma-rede-nacional-de-pessoas-com-impressoras-3d/",
        },
        {
          image: "6.png",
          title: "Jornal Cidades exalta atuação do Maker Market",
          link: "https://app.makermarket.com/jornal-cidades20252606.pdf",
        },
        {
          image: "5.png",
          title:
            "Empresas sediadas no Pelotas Parque Tecnológico vivem fase de expansão e crescimento",
          link: "https://diariodamanhapelotas.com.br/site/empresas-sediadas-no-pelotas-parque-tecnologico-vivem-fase-de-expansao-e-crescimento/",
        },
        {
          image: "7.png",
          title:
            "5 eventos de moda e beleza no RS para colocar na agenda dos próximos dias",
          link: "https://www.correiodopovo.com.br/bellamais/agenda/5-eventos-de-moda-e-beleza-no-rs-para-colocar-na-agenda-dos-pr%C3%B3ximos-dias-1.1637891",
        },
        {
          image: "8.png",
          title:
            "Desfile de moda com roupas em impressão 3D será destaque na Feira ArtWear, em Pelotas/RS",
          link: "https://portalabcpaulista.com.br/desfile-de-moda-com-roupas-em-impressao-3d-sera-destaque-na-feira-artwear-em-pelotas-rs/",
        },
        {
          image: "9.png",
          title:
            "Desfile de moda com roupas em impressão 3D será destaque na Feira ArtWear",
          link: "https://modaeventos.com.br/desfile-de-moda-com-roupas-em-impressao-3d/",
        },
      ],
    };
  },
  computed: {
    // Duplica a lista para criar o efeito contínuo
    repeatedLogos() {
      return [...this.logos, ...this.logos];
    },
  },
};
</script>

<style scoped>
.logo-scroller:hover .logo-track {
  animation-play-state: paused;
}

.logo-scroller {
  overflow: hidden;
  width: 100%;
  position: relative;
  height: 150px;
  padding-top: 20px;
}

.logo-track {
  display: flex;
  width: max-content;
  animation: scroll-left 35s linear infinite;
}

.logo-item {
  flex: 0 0 auto;
  padding: 0 30px;
  display: flex;
  align-items: center;
  justify-content: center;
}

@keyframes scroll-left {
  0% {
    transform: translateX(0%);
  }
  100% {
    transform: translateX(-50%);
  }
}

.logo-img {
  filter: grayscale(100%);
  transition: transform 0.7s ease, filter 0.7s ease;
  cursor: pointer;
}

.logo-img:hover {
  filter: grayscale(0%);
  transform: scale(1.1);
}

.visto-subtitle {
  font-size: 15px;
  font-weight: bold;
  max-width: 700px;
  line-height: 1.5;
  font-family: Helvetica;
  color: #777;
  text-align: left;
}
</style>
